import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import './style.css';

class CoverImage extends Component {
    render() {
        const { data, children } = this.props;
        const img = require(`../../images/${data.image}.jpg`);

        return (
            <div className="cover">
                <ReactCSSTransitionGroup
                    transitionName="cover-fade"
                    transitionAppear={true}
                    transitionAppearTimeout={500}
                    transitionEnterTimeout={500}
                    transitionLeaveTimeout={300}
                >
                    <div className="cover__image" style={{ backgroundImage: `url('${img}')` }}>
                        <h2 className="cover__title">{data.title}</h2>
                        <img src={img} alt={data.title} />
                        {children}
                    </div>
                </ReactCSSTransitionGroup>
            </div>
        );
    }
}

export default CoverImage;



// WEBPACK FOOTER //
// ./src/components/CoverImage/index.js